import { drupalComponent } from '@nech/src/helpers/drupal-component';

(function (Drupal, $) {
  drupalComponent('global_searchfield', {
    selector: '.nech-global-searchfield',
    shared: {
      hideModal:function($el:JQuery<HTMLElement>){
        $el.removeClass('opacity-1').addClass('opacity-0');
        $el.addClass('-translate-y-full');
        $el.addClass('-z-[1]');
      }
    },

    instance() {
      const self = this;
      const $el = $(this.selector);
      const $input = $el.find('.global-searchfield--input');
      const $closeButtonIcon = $el.find('.global-search--close-button-icon');
      const numberCharsToShowCloseIcon = 1;
      const $modal = $el.parent('.modal-search--container').find('.modal-search--dropdown');
      const $form = $('#nech-global-searchfield--form-modal-search');
      const $searchIcon = $el.find('.nech-global-searchfield--search-icon');
      const searchBaseUrl = $form.data('search-base-url');

      $input.on('input', function () {
        let inputValue = $(this).val();
        if (typeof inputValue === 'string' && inputValue.trim().length >= numberCharsToShowCloseIcon) {
            inputValue = encodeURI(inputValue.trim());
            $closeButtonIcon.removeClass('hidden');
        } else {
            $closeButtonIcon.addClass('hidden');
        }

        if (searchBaseUrl) {
          const redirectionLink = `${searchBaseUrl}/${inputValue}`;
          $form.attr('action', redirectionLink);
          $searchIcon.attr('href', redirectionLink);
        }
      });

      //for firefox browser
      $closeButtonIcon.on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        const isFirefox = (window as any).InstallTrigger !== undefined;
        if (isFirefox) {
          $input.val('');
          $closeButtonIcon.addClass('hidden');
          self.shared.hideModal($modal);
          $input.trigger('focus');
        }
      })

    },
  });
})(Drupal, jQuery);
